export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنشيط الشيك الإلكتروني"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حساب الائتمان"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرقم"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["السلسلة"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التنشيط"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحقق"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنشيط"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل الشيك الإلكتروني"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المبلغ"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الحالة"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نشط"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مُفعّل"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ملغى"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قيد التفعيل"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قيد الإرجاع"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قيد الانتظار"])}
  }
}